var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text_btn_primary1",on:{"click":_vm.printWord}},[_vm._v(" 导出 ")]),_c('div',{staticClass:"text_btn_primary1",on:{"click":_vm.printExp}},[_vm._v(" 导出解析 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }